export enum DeliverableTabOption {
  CATALOG = 'Catalog',
  CUSTOM = 'Custom',
  EDIT = 'Edition',
  DETAIL = 'Detail',
  FEEDBACK = 'Feedback',
}
